import { render, staticRenderFns } from "./NetDescription.vue?vue&type=template&id=f0270326&scoped=true&"
import script from "./NetDescription.vue?vue&type=script&lang=js&"
export * from "./NetDescription.vue?vue&type=script&lang=js&"
import style0 from "./NetDescription.vue?vue&type=style&index=0&id=f0270326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0270326",
  null
  
)

export default component.exports